import React from "react";
import { Box, Typography } from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { ImageMetadata } from "../types";
import { pieColors, renderPieLabel } from "./PieChartComponent";

interface FrameTypeDistributionChartProps {
  imagesForView: ImageMetadata[];
}

const DEFAULT_COLOR = "#8884d8";

const FrameTypeDistributionChart: React.FC<FrameTypeDistributionChartProps> = ({
  imagesForView,
}) => (
  <Box
    sx={{
      bgcolor: "background.paper",
      borderRadius: 3,
      p: 3,
      boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
      minHeight: 340,
    }}
  >
    <Typography
      variant="h6"
      sx={{ fontWeight: 700, color: "text.primary", mb: 0.5 }}
    >
      Frame Type Distribution
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Distribution of different frame types
    </Typography>
    <Box
      sx={{
        width: "100%",
        height: 220,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#181818",
        borderRadius: 2,
      }}
    >
      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie
            data={(() => {
              const types = ["LIGHT", "DARK", "FLAT", "BIAS"];
              return types.map((type) => ({
                name: type,
                value: imagesForView.filter((img) => {
                  if ((img as any).FrameType) {
                    return (img as any).FrameType === type;
                  }
                  if (type === "LIGHT" && img.FilterName) return true;
                  return false;
                }).length,
              }));
            })()}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill={DEFAULT_COLOR}
            stroke="#222"
            label={renderPieLabel}
          >
            <Cell key="LIGHT" fill={pieColors.LIGHT} />
            <Cell key="DARK" fill={pieColors.DARK} />
            <Cell key="FLAT" fill={pieColors.FLAT} />
            <Cell key="BIAS" fill={pieColors.BIAS} />
          </Pie>
          <Tooltip
            contentStyle={{
              background: "#222",
              border: "1px solid #444",
              color: "#fff",
            }}
            labelStyle={{ color: "#fff" }}
          />
          <Legend
            iconType="circle"
            wrapperStyle={{ color: "#a0a0a0" }}
            payload={["LIGHT", "DARK", "FLAT", "BIAS"].map((type) => ({
              value: type.charAt(0) + type.slice(1),
              type: "circle",
              color: pieColors[type],
            }))}
          />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  </Box>
);

export default FrameTypeDistributionChart;
